<template>
  <div>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4 text-center" data-aos="fade-in">
            <img src="../assets/logo-dark@3x.png" alt="Image: Vintrigue Logo">
          </div>
          <div class="col-8 col-md-4" data-aos="fade-in">
            <h3 class="section--title">Contact</h3>
            <a v-bind:href="'tel:' + this.$root.store.telephone_number">{{ this.$root.store.telephone_number }}</a>
            <a v-bind:href="'mailto:' + this.$root.store.contact_email">{{ this.$root.store.contact_email }}</a>
            <p>Vintrigue from Lanchester Wines,<br>
              Greencroft Estate, Tower Road, <br>
              Annfield Plain, Stanley, <br>
              Co. Durham, DH9 7XP
            </p>
            <p>AWRS Registration No.: XRAW00000101534</p>
          </div>
          <div class="col-4 social" data-aos="fade-in">
            <a href="https://www.instagram.com/lanchesterwines/">Instagram</a>
            <a href="https://www.youtube.com/channel/UC6-teDsMv0r7JO_Q9D7muzw">YouTube</a>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-expand bg-dark">
        <div class="container">
          <ul class="navbar-nav justify-content-center">
            <li class="nav-item">
              <router-link ref="link" :to="{ name: 'terms'}" class="nav-link" title="Link: Terms and Conditions">
                Terms &amp; Conditions
              </router-link>
            </li>
            <li class="nav-item">
              <router-link ref="link" :to="{ name: 'privacy'}" class="nav-link" title="Link: Privacy Policy">
                Privacy Policy
              </router-link>
            </li>
            <li class="nav-item">
              <a target="_blank" class="nav-link" title="Link: Modern Slavery"
                 href="https://www.lanchestergroup.com/wp-content/uploads/2020/09/Slavery-and-Human-Trafficking-2020.pdf">
                Modern Slavery
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'SiteFooter'
  }
</script>
